import axios from 'axios'
// 判斷當前系統環境開發or上線
var isPro = process.env.NODE_ENV === 'production'
var ApiIP = window.g.APIServeIP + ':' + window.g.InnerAPIport
// API
const NukApi = axios.create({
  // 當isPro 為true 則 ApiUrl 否 走代理 /apis
  baseURL: isPro ? ApiIP : '/apis' // 中冠
})

// 一：帳號登入/管理
//  1.登入 API_000
export const apiAccountLogin = data => NukApi.post('api/account/login', data)
//  2.帳號查詢 API_001
export const apiAccountQuery = data => NukApi.post('api/account/query', data)
//  3.帳號變更 API_002
export const apiAccountModify = data => NukApi.post('api/account/modify', data)
//  4.權限變更 API_002_1
export const apiAccountChange = data => NukApi.post('api/account/change', data)

// 二：教務證件-種類管理
//  1. 種類查詢 API_003
export const apiDocumentsQuery = data => NukApi.post('api/documents/query', data)
//  2. 種類新增 API_004
export const apiDocumentsAdd = data => NukApi.post('api/documents/add', data)
//  3. 種類修改 API_005
export const apiDocumentsModify = data => NukApi.post('api/documents/modify', data)
//  4. 種類刪除 API_006
export const apiDocumentsDelete = data => NukApi.post('api/documents/delete', data)

// 三：教務證件-訂單管理
//  1.訂單查詢 API_007
export const apiOrderQuery = data => NukApi.post('api/order/query', data)
//  2.訂單新增 API_008
export const apiOrderAdd = data => NukApi.post('api/order/add', data)
//  3.修改備註 API_009
export const apiOrderModify = data => NukApi.post('api/order/modify', data)
//  3-1 修改數量 API_009-1
export const apiOrderModifycnt = data => NukApi.post('api/order/modifycnt', data)
//  4.結帳 API_010
export const apiOrderCheckout = data => NukApi.post('api/order/checkout', data)
//  5.郵件號碼 API_011
export const apiOrderMailnoadd = data => NukApi.post('api/order/mailnoadd', data)
//  6.訂單刪除 API_012
export const apiOrderDelete = data => NukApi.post('api/order/delete', data)
//  7.明細刪除 API_013
export const apiOrderDetaildelete = data => NukApi.post('api/order/detaildelete', data)
//  8.全部列印 API_014
export const apiOrderPrintall = data => NukApi.post('api/order/printall', data)
//  9.單筆列印 API_015
export const apiOrderPrint = data => NukApi.post('api/order/print', data)

// 四：郵資管理
//  1.郵資查詢 API_016
export const apiPostageQuery = data => NukApi.post('api/postage/query', data)
//  2.郵資新增 API_017
export const apiPostageAdd = data => NukApi.post('api/postage/add', data)
//  3.郵資修改 API_018
export const apiPostageModify = data => NukApi.post('api/postage/modify', data)
//  4.郵資刪除 API_019
export const apiPostageDelete = data => NukApi.post('api/postage/delete', data)

// 五：報表查詢
//  1.明細報表查詢 API_020
export const apiReportDetailquery = data => NukApi.post('api/report/detailquery', data)
//  2.結帳報表查詢 API_021
export const apiReportCheckoutquery = data => NukApi.post('api/report/checkoutquery', data)
